import SearchIcon from '@mui/icons-material/Search';
import { Button, useTheme } from '@mui/material';
import React from 'react';

import { searchButtonSx } from './filterBarStyles';
import { getSearchButtonDirtySx } from './searchButtonDirtyState';

export interface FilterBarSearchButtonProps {
  onClick: () => void;
  ariaLabel: string;
  /** Filters have changed without being applied — the button says so. */
  isDirty: boolean;
  /** Id of the visually hidden text describing the pending state. */
  pendingHintId: string;
  /** Whether a trailing search box is claiming the right-hand edge. */
  hasTrailingSearchBox: boolean;
}

/** The primary action. Split out of `FilterBar` to keep it inside the
 *  project's 250-line file budget. */
export const FilterBarSearchButton: React.FC<FilterBarSearchButtonProps> = ({
  onClick,
  ariaLabel,
  isDirty,
  pendingHintId,
  hasTrailingSearchBox,
}) => {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      size="small"
      // Flat, not raised: the strip's controls are all outlined and the shadow
      // was the only thing on it casting one.
      disableElevation
      startIcon={<SearchIcon sx={{ fontSize: 15 }} />}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-describedby={isDirty ? pendingHintId : undefined}
      sx={{
        ...searchButtonSx(theme),
        // Whoever is rightmost claims the edge: a trailing search box takes
        // `ml: auto` itself, otherwise the button does — without which it would
        // sit next to Add Filter on the pages that have no search box.
        ...(hasTrailingSearchBox ? {} : { ml: 'auto' }),
        ...getSearchButtonDirtySx(theme, isDirty),
      }}
    >
      Search
    </Button>
  );
};
